module.exports = __webpack_public_path__ + "img/light-logo.04dd0d03.png";